import useSWR from 'swr';
import Auth from '../Auth';
import { useEffect, useState } from 'react';

export default function useProfile() {
  const [profile, setProfile] = useState(null);

  const { data, error, isLoading } = useSWR(`/api/profiles/me`, Auth.fetchWithIdToken, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (data && !isLoading) {
      setProfile(data.profile);
    }
  }, [data, isLoading]);

  return { profile, isLoading, error };
}
